import React from 'react';
import { StoryCard } from '../StoryCard';

class RegistrationCard extends StoryCard<any> {
	render() {
		return <div className="registration-card">{super.renderCard()}</div>;
	}
}

export default RegistrationCard;
